module.exports = __webpack_public_path__ + "img/2-1-venue-overview.12bdd891.jpg";